import jwt_decode from "jwt-decode"
import AxiosLibWithHeader2 from "../../Library/AxiosLibWithHeader2";

const AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = ((AuthToken) ? jwt_decode(AuthToken) : []);

const Request2Estes = async (param) =>{
    const keys = {
        "AppId": AuthDecode.AppID,
        "AppEnv": AuthDecode.AppEnv,
        "Secretkey": AuthDecode.secretkey
    };

    const postData = {
        keys: keys,
        body: param
    };

    const results = await AxiosLibWithHeader2(postData, 'app/api/req-module')
            .then(
                response => {
                    if(response.error) {
                        return {loading: false, data: [], message: response.error}
                    } else if ("message" in response.response) {
                        const msg = response.response.message.user;
                        return {loading: false, data: [], message: msg}
                    }else{
                        const data = response.response.data;
                        return {loading: false, data: data, message: ""}
                    }
                }
            );

    return results;
}

const GET_SECTION = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_SECTION"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const GET_ATD_LECTURER_BY_SECTION = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_ATD_LECTURER_BY_SECTION"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const UPDATE_ATD_LECTURER = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "UPDATE_ATD_LECTURER"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const GET_ATD_LECTURER_BY_ATDID = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_ATD_LECTURER_BY_ATDID"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const UPDATE_STD_ATD_BY_LEC = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "UPDATE_STD_ATD_BY_LEC"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const GET_STUDENT_ACTIVITY = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_STUDENT_ACTIVITY"
    };
    const results = await Request2Estes(param_post);

    return results;
}

const GET_STUDENT_ACTIVITY_DETAIL = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_STUDENT_ACTIVITY_DETAIL"
    };
    const results = await Request2Estes(param_post);

    return results;
}


const GET_COUNSELING_BY_LECTURER = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_COUNSELING_BY_LECTURER"
    };
    const results = await Request2Estes(param_post);

    return results;
}


const GET_SCR_STUDENT_BY_ATPID = async (param) =>{
    const param_post = {
        "parameters": param,
        "target_data": "GET_SCR_STUDENT_BY_ATPID"
    };
    const results = await Request2Estes(param_post);

    return results;
}


export {Request2Estes, GET_STUDENT_ACTIVITY, GET_SECTION, GET_ATD_LECTURER_BY_SECTION, UPDATE_ATD_LECTURER, GET_ATD_LECTURER_BY_ATDID, UPDATE_STD_ATD_BY_LEC, GET_COUNSELING_BY_LECTURER, GET_STUDENT_ACTIVITY_DETAIL, GET_SCR_STUDENT_BY_ATPID}